<template>
  <f7-page>
    <navbar :text="`${$t('LeftPanel_title_ParcelSystem')} > ${actualUser.name} >  ${actualLocation.name} > ${$t('parcels')}`" />
    <f7-block class="content-devx">
      <f7-block-title>
        <span>{{ `${$t('parcel.register.title')}` }}</span>
      </f7-block-title>
      {{ $t("parcel.register.step2") }}
    </f7-block>
    <f7-block v-if="!loadedGIS">
      {{ $t("formAction_Alert_EnableGPS") }}
    </f7-block>
    <f7-block v-else>
      <GISEditorSigpac
        :zoom="zoom"
        :name-map="mainMap"
        :center="center"
        :tree-locations="treeLocations"
        :disabled-edit-parcel="false"
        :show-marker="showMarker"
      />
    </f7-block>

    <Parcel-info
      :land-size="areaToDisplay"
      :lang="lngToDisplay"
      :lat="latToDisplay"
    />

    <f7-row>
      <f7-col>
        <f7-button
          class="dx-btn-cancel margin-right"
          raised
          type="default"
          text-color="grey"
          styling-mode="outlined"
          name="ButtonCancel"
          @click="goToBack()"
        >
          {{ $t("Button_go_to_back") }}
        </f7-button>
      </f7-col>
      <f7-col>
        <f7-button
          v-if="loadedGIS"
          class="dx-btn-success"
          raised
          type="success"
          styling-mode="contained"
          @click="registerParcel"
        >
          {{ $t("save") }}
        </f7-button>
      </f7-col>
    </f7-row>
    <PopupRegisterParcelStep2 />
  </f7-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import navbar from '../../components/NavBar.vue';
import GISEditorSigpac from '../../components/Gis/GISEditorSigpac/index.vue';
import PopupRegisterParcelStep2 from '../../components/parcel/popupRegisterParcelStep2/index.vue';
import ParcelInfo from '../../components/parcel/parcelInfo/index.vue';

export default {
  name: 'RegisterParcelStep2Page',
  components: {
    navbar,
    GISEditorSigpac,
    PopupRegisterParcelStep2,
    ParcelInfo,
  },
  data() {
    return {
      zoom: 17,
      mainMap: 'mainMapParcel',
      center: {},
      loadedGIS: false,
      showMarker: false,
      editing: false,
    };
  },
  computed: {
    areaToDisplay() {
      if (typeof this.currentParcel.area !== 'undefined') {
        return this.currentParcel.area;
      }
      return this.area;
    },
    lngToDisplay() {
      if (typeof this.currentParcel.area !== 'undefined') {
        return this.currentParcel.coordinates.longitude;
      }
      return this.viewCentroide.lng;
    },
    latToDisplay() {
      if (typeof this.currentParcel.area !== 'undefined') {
        return this.currentParcel.coordinates.latitude;
      }
      return this.viewCentroide.lat;
    },
    ...mapState('RegisterLocation', [
      'name',
      'registerNumber',
      'province',
      'mobile',
      'farm',
      'ownerFarm',
      'registerExplotationId',
    ]),
    ...mapState('GisEditor', ['area', 'centroide', 'currentGeoFeature']),
    ...mapState('Explotaciones', ['actualLocation', 'actualUser']),
    ...mapState('Parcel', ['currentParcel', 'currentParcelId']),
    ...mapState('Plantation', ['treeLocations']),
    ...mapGetters('GisEditor', ['viewCentroide']),
  },
  beforeMount() {
    if (typeof this.currentParcel.id === 'undefined') {
      this.editing = false;
      // Establecer geolocalización
      const navigatorOptions = {
        enableHighAccuracy: true,
        maximumAge: 0,
      };
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          this.center = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          this.loadedGIS = true;
          this.showMarker = true;
        },
        (error) => {
          this.$f7.dialog.alert(
            `${error.message} - ${this.$t('formAction_Alert_EnableGPS')}`,
          );
        },
        navigatorOptions,
      );
    } else {
      this.editing = true;
      this.center = this.currentParcel.coordinates;
      this.showMarker = false;
      this.loadedGIS = true;
    }
  },
  methods: {
    async registerParcel() {
      this.$f7.preloader.show();
      try {
        if (this.area === 0 && this.editing === false) {
          this.$f7.dialog.alert(
            this.$t('parcel.register.geofeatures.requiredRule'),
          );
        } else {
          const companyId = this.actualUser.id;
          let geoFeature = null;
          if (this.area === 0) {
            this.setCentroide({ lat: this.currentParcel.coordinates.latitude, lng: this.currentParcel.coordinates.longitude });
            this.setArea(this.currentParcel.area);
            geoFeature = this.currentParcel.geo_feature;
          } else if (this.currentGeoFeature.features[0].geometry.coordinates.length !== 0) {
            geoFeature = this.currentGeoFeature;
          } else {
            geoFeature = this.currentParcel.geo_feature;
          }
          const newParcel = {
            name: this.currentParcel.name,
            geo_feature: geoFeature,
            type: 'ORGANIZATIVE', // Para parcelas siempre tiene ese valor
            coordinates: {
              latitude: this.centroide.lat,
              longitude: this.centroide.lng,
            },
            code: `${this.currentParcel.name}${Date.now()}`,
            parent:
              typeof this.actualLocation.bdId === 'undefined'
                ? this.registerExplotationId
                : this.actualLocation.bdId,
            properties: [
              {
                key: 'area',
                value: this.area,
              },
            ],
          };
          if (typeof this.currentParcel.id === 'undefined') {
            await this.createParcel({ companyId, newParcel });
            this.setShowPopup(true);
          } else {
            await this.updateParcel({ companyId, parcelUpdated: newParcel, parcelId: this.currentParcel.id });
            this.$f7.views.main.router.navigate('/viewParcel/', { reloadCurrent: true });
          }
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goToBack() {
      this.$f7.views.main.router.navigate('/registerParcelStep1/', {
        reloadCurrent: true,
      });
    },
    ...mapActions('Parcel', ['createParcel', 'updateParcel', 'setShowPopup']),
    ...mapActions('GisEditor', ['setCentroide', 'resetCentroide', 'setArea']),
  },
};
</script>

<style scoped>
</style>
